import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import styled from "styled-components";
import { showIpLogState } from "../pages/Users/UserDetail/UserDetailHeader";
import { menuFoldState } from "./Header";
import MenuItem from "./SideNavigation/MenuItem";
import { isBeta, isDev } from "../../AdminConfig";
import { dashboardTabState } from "../pages/Dashboard/DashboardTab";

interface SSideNavigationContainer {
  isFold?: boolean;
  isBeta?: boolean;
  isDev?: boolean;
}

export default function SideNavigation() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const fold = useRecoilValue(menuFoldState);
  const setShowIpLog = useSetRecoilState(showIpLogState);
  const setDashboardTabState = useSetRecoilState(dashboardTabState);

  const menuData = [
    {
      id: 1,
      title: "대시보드",
      child: [],
    },
    {
      id: 2,
      title: "회원 관리",
      child: ["회원 정보", "코멘트", "블랙리스트", "탈퇴 회원 정보"],
    },
    {
      id: 3,
      title: "파티 관리",
      child: [
        "파티 정보",
        "매칭 현황",
        "채팅",
        "파티 초대 관리",
        "구. 유플러스 결합",
        "유플러스 결합",
        "매치메이킹 파티",
        // "뉴_매치메이킹 파티",
        "링고키즈",
        "개인 연간 파티",
        "유튜브 프리미엄_해외"

      ],
    },
    {
      id: 4,
      title: "유저 로그",
      child: [],
    },
    {
      id: 5,
      title: "NEW 유저 로그",
      child: [],
    },
    {
      id: 6,
      title: "정산 관리",
      child: ["결제/적립/인출 정보", "예약 결제", "실패"],
    },
    {
      id: 7,
      title: "혜택 관리",
      child: ["쿠폰 관리", "포인트 관리", "스탬프 관리", "링크아이 사전예약","🔥 타임 이벤트"],
    },
    {
      id: 8,
      title: "메세지 관리",
      child: ["알림톡 관리", "LMS 관리", "알림톡 발송 실패"
        ,"앱 푸시 관리"
      ],
    },
    {
      id: 9,
      title: "링키드 관리",
      child: [
        "유효성 체크",
        "임시 계정 관리",
        "일몰 관리",
        "자주 묻는 질문 관리",
        "팝업 관리",
        "상태 관리",
        "공지사항",
        "약관 관리",
        "고객제안",
        "파티 탈퇴/해산 사유 확인",
      ],
    },
    {
      id: 10,
      title: "관리자",
      child: ["관리자 계정 관리", "운영 로그"],
    },
  ];

  const menuArray = Array(menuData?.length)?.fill(false);
  const menuObject: any = {};

  menuArray.forEach(function (item, index) {
    menuObject[index] = item;
  });

  const menuElement = document.getElementById("menu")!;
  const menuContentElement = document.getElementById("menu-content")!;

  const [menuState, setMenuState] = useState(menuArray);
  const [menuHeight, setMenuHeight] = useState(0);

  const menuContentRef = useRef<HTMLDivElement | null>(null);

  let hasMore = menuContentElement
    ? window.innerHeight - 40 - 32.5 - 84 < menuHeight
    : false;

  useLayoutEffect(() => {
    setTimeout(() => {
      setMenuHeight(menuContentRef?.current?.offsetHeight ?? 0);
    }, 200);
  }, [menuState]);

  useEffect(() => {}, [menuHeight]);

  useEffect(() => {
    if (pathname?.includes("dashboard")) {
      setMenuState({
        ...menuArray,
        0: true,
      });
    } else if (pathname?.includes("users/")) {
      setMenuState({
        ...menuArray,
        1: true,
      });
    } else if (pathname?.includes("party/")) {
      setMenuState({
        ...menuArray,
        2: true,
      });
    } else if (pathname?.includes("/userlog")) {
      setMenuState({
        ...menuArray,
        3: true,
      });
    } else if (pathname?.includes("new-userlog")) {
      setMenuState({
        ...menuArray,
        4: true,
      });
    } else if (pathname?.includes("pay/")) {
      setMenuState({
        ...menuArray,
        5: true,
      });
    } else if (pathname?.includes("benefit/")) {
      setMenuState({
        ...menuArray,
        6: true,
      });
    } else if (pathname?.includes("message/")) {
      setMenuState({
        ...menuArray,
        7: true,
      });
    } else if (pathname?.includes("/linkid-manage/")) {
      setMenuState({
        ...menuArray,
        8: true,
      });
    } else if (pathname?.includes("/manage/")) {
      setMenuState({
        ...menuArray,
        9: true,
      });
    } else {
      setMenuState({
        ...menuArray,
      });
    }
  }, [pathname]);

  return (
    <SideNavigationContainer isFold={fold} isBeta={isBeta} isDev={isDev}>
      <Link to="/">
        <div>
          <AdminLogo isBeta={isBeta} isDev={isDev}>
            <img
              src={require("../../assets/sideNavigation/logo-linkidwordmark@2x.png")}
              alt="linkid"
            />

            <AdminLogoText>Admin</AdminLogoText>

            {/* {isBeta && (
              <BetaLogo
                src={require("../../assets/header/ic_beta@2x.png")}
                alt="beta"
              />
            )} */}
          </AdminLogo>
        </div>
      </Link>

      <Menu id="menu">
        <div id="menu-content" ref={menuContentRef}>
          {menuData?.map((m, idx) => {
            return (
              <MenuItem
                key={m?.id}
                onClickEvent={() => {
                  setMenuState({
                    ...menuState,
                    [idx]: !menuState[idx],
                  });

                  if (m?.id === 1) {
                    setDashboardTabState(0);
                    navigate("dashboard");
                  } else if (m?.id === 4) {
                    setShowIpLog({
                      state: false,
                      uid: 0,
                    });
                    navigate("userlog");
                  } else if (m?.id === 5) {
                    navigate("new-userlog");
                  }
                }}
                isClicked={menuState[idx]}
                title={m?.title}
                child={m?.child}
              />
            );
          })}
        </div>
      </Menu>

      {hasMore && (
        <HasMoreBtnContainer
          onClick={() => {
            if (menuElement) {
              menuElement.scrollTo({
                top: menuHeight,
                behavior: "smooth",
              });
            }
          }}
        >
          <HasMoreBtn
            src={require("../../assets/sideNavigation/more_navigation_28@2x.png")}
          />
        </HasMoreBtnContainer>
      )}
    </SideNavigationContainer>
  );
}

const SideNavigationContainer = styled.div<SSideNavigationContainer>`
  visibility: ${({ isFold }) => (isFold ? "hidden" : "visible")};
  position: fixed;
  left: 0;
  top: 0;
  width: 240px;
  height: 100%;
  background-color: ${({ isBeta, isDev }) =>
    isBeta ? "#6e2d95" : isDev ? "#6e2d22" : "#2f2f37"};
  padding: 24px 10px 40px 24px;
  transition: visibility 0.05s ease;
`;

const AdminLogo = styled.div<SSideNavigationContainer>`
  cursor: pointer;
  margin-left: ${({ isBeta, isDev }) => (isBeta ? 4 : isDev ? 4 : 18)}px;
  display: flex;
  align-items: center;

  img {
    height: 22px;
  }
`;

const AdminLogoText = styled.span`
  font-size: 20px;
  line-height: 32.5px;
  letter-spacing: 0.4px;
  text-align: left;
  color: ${({ theme }) => theme.color.white};
`;

const Menu = styled.div`
  margin-top: 40px;
  width: 100%;
  max-height: calc(100vh - 40px - 32.5px - 84px);
  height: auto;
  overflow-y: scroll;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;

const HasMoreBtnContainer = styled.div`
  margin-top: 10px;
  width: 100%;
  text-align: center;
`;

const HasMoreBtn = styled.img`
  cursor: pointer;
  width: 28px;
  height: 28px;
  opacity: 0.3;
`;

export const BetaLogo = styled.img`
  width: 50px;
  aspect-ratio: auto 2/1;
`;
